import apiClient from './api';

export const getAllColors = () => apiClient.get("/tile/colors");

export const upsertUserPreferences = (userId, preferences) => apiClient.put(`/tile/preferences/${userId}`, preferences);

export const getDefaultPreferences = (status) => apiClient.get(`/tile/default-preferences/${status}`);

export const upsertDefaultPreferences = (status, preferences) => apiClient.put(`/tile/default-preferences/${status}`, preferences);

export const getDefaultTiles = (status, userId) => apiClient.get(`/tile/default-tiles/${status}/${userId}`);
export const getDefaultTilesNoUser = (status) => apiClient.get(`/tile/default-tiles-default/${status}`);

export const getUserPreferences = (userId) => apiClient.get(`/tile/preferences/${userId}`);

export const getUnusedTiles = (userId) => apiClient.get(`/tile/unused/${userId}`);

export const getTilesTypeLink = () => apiClient.get(`/tile/all-tiles/type-link`);

export const createTileTypeLink = (data) => apiClient.post(`/tile/type-link/create`, data);

export const deleteTileTypeLink = (tileId, userId) => apiClient.delete(`/tile/type-link/${tileId}/${userId}`);

export const proposeTile = (userId, data) => apiClient.post(`/tile/propose/${userId}`, data);

export const getTileProposals = () => apiClient.get(`/tile/proposals`);

export const validateTileProposal = (proposalId, userId, tileId) => apiClient.put(`/tile/proposal/validate/${proposalId}`, { userId, tileId });

export const declineTileProposal = (proposalId, userId) => apiClient.put(`/tile/proposal/decline/${proposalId}`, { userId });

export const getTilesHasNew10D = () => apiClient.get(`/tile/tiles-has-new-10d`);

export const getKamaeScore = (email) => apiClient.get(`/tile/kamae-score?email=${email}`);

// Appliquer une tuile obligatoire à tous les utilisateurs (insertion automatique)
export const applyMandatoryTile = (tileId, tileTypeId, tableName = 'T_J_PREFERENCE_PRF') =>
  apiClient.post(`/tile/mandatory/apply`, { tileId, tileTypeId, tableName });

// Compter le nombre d'utilisateurs concernés (distinct USR_ID)
export const getMandatoryUsersCount = (tableName = 'T_J_PREFERENCE_PRF') =>
  apiClient.get(`/tile/mandatory/users/count`, { params: { tableName } });